export enum DateSelect {
    All = 'all',
    Today = 'today',
    LastSeven = 'lastSeven',
    LastThirty = 'lastThirty',
    LastYear = 'lastYear'
}